import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'border-system-gray-300 -order-1 flex h-fit w-full items-center justify-between gap-2 border-b-1 bg-white px-4.5 pt-1 pb-2 md:pb-[10px] lg:hidden lg:pb-0',
    addToCart: 'static flex-1 xl:min-w-94',
    counter: 'static',
    wishlist: 'flex-center flex size-[50px]',
    wishlistIcon: 'size-8 md:size-8',
    compare: 'size-8 group-hover/tile:opacity-100 md:size-8',
    compareIcon: 'h-full w-full',
    actions: 'flex w-[25%] items-center justify-between gap-4'
  }
});
